import axios from 'axios';
import { toast } from 'react-toastify';

// Action Types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const LOGOUT_APP = 'LOGOUT_APP';

export const loginRequest = () => ({ type: LOGIN_REQUEST });
export const loginSuccess = (user) => ({ type: LOGIN_SUCCESS, payload: user });
export const loginFailure = (error) => ({ type: LOGIN_FAILURE, payload: error });
export const loginRefreshToken = (data) => ({ type: REFRESH_TOKEN, payload: data });
export const logoutApp = () => ({ type: LOGOUT_APP, payload: null });
export const forgotPassSuccess = () => ({ type: LOGIN_SUCCESS, payload: "" });
export const checkValidResetLinkRequest = () => ({ type: "CHECK_VALID_RESET_LINK_REQUEST" });
export const checkValidResetLinkSuccess = () => ({ type: "CHECK_VALID_RESET_LINK_SUCCESS", payload: "" });
export const checkValidResetLinkFailure = (error) => ({ type: "CHECK_VALID_RESET_LINK_FAILURE", payload: error });


export const login = (email, password) => async (dispatch) => {  
  dispatch(loginRequest());
  let requestData= {
    email:email,
    password:password,
  }
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/login`, requestData);
    
    // Check if response has error or invalid data
    if (!response.data || !response.data.id_token) {
        dispatch(loginFailure('Invalid email or password!'));
        toast.error('Invalid email or password!');
        return { success: false };
    }
    
    // Store tokens in appropriate storage
    // auth_token in sessionStorage (cleared on tab close)
    sessionStorage.setItem('auth_token', response.data.id_token);
    // refreshToken in localStorage (persists across sessions)
    localStorage.setItem('refreshToken', response.data.refresh_token);
    // Store expire_time for token expiration tracking
    if (response.data.expire_time) {
        const expirationTime = Date.now() + response.data.expire_time;
        sessionStorage.setItem('token_expire_time', expirationTime.toString());
    }
    
    // Update Redux state with login data
    dispatch(loginSuccess(response.data));
    toast.success('Login successful!');   
    
    // Call UserDetails API immediately after login
    try {
        await dispatch(UserDetails());
    } catch (userError) {
        // UserDetails error handling is done in UserDetails function
        // Continue with login success even if user details fail
    }
    
    return { success: true, data: response.data };
    
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Login failed. Please try again.';
    dispatch(loginFailure(errorMessage));
    toast.error(errorMessage);
    return { success: false };
  }
};
export const forgot_password = (email) => async (dispatch) => {  
    dispatch(loginRequest());
    let requestData= {
      email:email,
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/forgot-password`, requestData);
      if(response.data.success === true){
        dispatch(forgotPassSuccess());
        toast.success(response.data.message);           
      }else{
        dispatch(loginFailure('Something went wrong , Please try again!'));
        toast.error('Something went wrong , Please try again!')    
      }
      
    } catch (error) {
      toast.error('Session Expired');
      dispatch(LogoutApp());
    }
};

export const isLinkValid = (auth_code) => async (dispatch) => {  
    dispatch(loginRequest());
    
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/auth/activate/${auth_code}`);
        
        if (response.data.success) {
            dispatch(forgotPassSuccess());
            const message = response.data.message || "Your account has been activated.";
            toast.success(message);
            return response.data; // Return the response data
        } else {
            const errorMsg = 'Something went wrong, Please try again!';
            dispatch(loginFailure(errorMsg));
            toast.error(errorMsg);
            return { success: false, message: errorMsg };
        }
        
    } catch (error) {
        const errorMsg = 'Session Expired';
        toast.error(errorMsg);
        dispatch(LogoutApp());
        return { success: false, message: errorMsg };
    }
};

export const checkValidResetLink = (auth_code) => async (dispatch) => {  
    dispatch(checkValidResetLinkRequest());
    
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/auth/check-reset-link/${auth_code}`);
        
        if (response.data.success) {
            dispatch(checkValidResetLinkSuccess());
            const message = response.data.message ;
            toast.success(message);
            return response.data; // Return the response data
        } else {
            const errorMsg = 'Something went wrong, Please try again!';
            dispatch(checkValidResetLinkFailure(errorMsg));
            toast.error(errorMsg);
            return { success: false, message: errorMsg };
        }
        
    } catch (error) {
        const errorMsg = error.response?.data?.message || 'Something went wrong';
        toast.error(errorMsg);
        return error.response?.data || { success: false, message: errorMsg };
    }
};
export const userActivation = (activatekey) => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/account/activate/${activatekey}`);
        
        if (response.data.success) {
            const message = response.data.message;
            toast.success(message);
            return response.data;
        } else {
            const errorMsg = 'Something went wrong, Please try again!';
            toast.error(errorMsg);
            return { success: false, message: errorMsg };
        }
        
    } catch (error) {
        const errorMsg = error.response?.data?.message || 'Something went wrong';
        return error.response?.data || { success: false, message: errorMsg };
    }
};
export const reset_password = (code, password) => async (dispatch) => {  
    dispatch(loginRequest());
    let requestData= {
        resetKey:code,
        password:password,
    }
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/reset-password`, requestData);
        if(response.data.success === true){
            dispatch(forgotPassSuccess());
            toast.success(response.data.message);        
            return { success: true };
        }else{
        dispatch(loginFailure('Something went wrong , Please try again!'));
        toast.error('Something went wrong , Please try again!')    
        }
        
    } catch (error) {
        toast.error('Session Expired');
        dispatch(LogoutApp());
    }
};

export const UserDetails = () => async (dispatch) => { 
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
        toast.error('Authentication token missing. Please log in.');
        return dispatch(LogoutApp());
    }

    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/user`, {
            headers: { Authorization: `Bearer ${authToken}` },
        });
        // Store user data in sessionStorage (cleared on tab close)
        sessionStorage.setItem('user', JSON.stringify(response.data));
        dispatch({ type: "USER", payload: response.data });
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response && error.response.status === 401) {
            toast.error('Session Expired. Please log in again.');
            dispatch(LogoutApp());
        } else {
            toast.error('Failed to fetch user details.');
        }
        return { success: false };
    }
};

export const getAllUsersDetails = () => async (dispatch) => { 
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
        toast.error('Authentication token missing. Please log in.');
        return dispatch(LogoutApp());
    }

    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/account/list`, {
            headers: { Authorization: `Bearer ${authToken}` },
        });
        dispatch({ type: "ALL_USERS", payload: response.data });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            toast.error('Session Expired. Please log in again.');
            dispatch(LogoutApp());
        } else {
            toast.error('Failed to fetch user data.');
        }
    }
};
export const createUser = (formData) => async (dispatch) => { 
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
        toast.error('Authentication token missing. Please log in.');
        return dispatch(LogoutApp());
    }
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/account`,formData, {
            headers: { Authorization: `Bearer ${authToken}` },
        });
        if(response.data.success){
            toast.success(response.data.message);  
        }else{
            toast.error(response.data.message);  
        }
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            toast.error('Session Expired. Please log in again.');
            dispatch(LogoutApp());
        } else {
            toast.error('Failed to create user.');
        }
    }
};
export const refreshToken = () => async (dispatch) => { 
    const refreshTokenValue = localStorage.getItem('refreshToken');
    if (!refreshTokenValue) {
        dispatch(LogoutApp());
        return { success: false };
    }
    
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/refresh`, {"refresh_token": refreshTokenValue });
        
        // Check if response has error or invalid data
        if (!response.data || !response.data.id_token) {
            dispatch(loginFailure('Token refresh failed!'));
            toast.error('Token refresh failed!');
            dispatch(LogoutApp());
            return { success: false };
        }
        
        // Update auth_token in sessionStorage
        sessionStorage.setItem('auth_token', response.data.id_token);
        
        // Update expire_time if provided
        if (response.data.expire_time) {
            const expirationTime = Date.now() + response.data.expire_time;
            sessionStorage.setItem('token_expire_time', expirationTime.toString());
        }
        
        // Update refresh_token if backend provides a new one
        if (response.data.refresh_token) {
            localStorage.setItem('refreshToken', response.data.refresh_token);
        }
        
        const data = response.data;
        dispatch(loginRefreshToken(data));
        return { success: true, data: data };
        
    } catch (error) {
        const errorMessage = error.response?.data?.message || 'Session Expired';
        toast.error(errorMessage);
        dispatch(LogoutApp());
        return { success: false };
    }
};

export const LogoutApp = () => async (dispatch) => { 
    const auth_token = sessionStorage.getItem('auth_token');

    try {
        if (auth_token) {
            let headerData = {
                "Authorization":`Bearer ${auth_token}`
            }
            await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/auth/logout`, {headers: headerData });
        }
    } catch (error) {
        // Continue with logout even if API call fails
    } finally {
        // Clear sessionStorage (auth_token, user, token_expire_time)
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('auth_token');
        sessionStorage.removeItem('token_expire_time');
        
        // Clear localStorage (refreshToken)
        localStorage.removeItem('refreshToken');
        
        dispatch(logoutApp());
        toast.success('Logout successful!');  
        return { success: true };
    }
};